"use strict";

exports.__esModule = true;
exports.PLUGIN_PRIORITY = exports.PLUGIN_KEY = exports.AutoColumnSize = void 0;
var _autoColumnSize = require("./autoColumnSize");
exports.PLUGIN_KEY = _autoColumnSize.PLUGIN_KEY;
exports.PLUGIN_PRIORITY = _autoColumnSize.PLUGIN_PRIORITY;
exports.AutoColumnSize = _autoColumnSize.AutoColumnSize;


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/plugins/autoColumnSize/index.js
// module id = 1229
// module chunks = 0